import React from "react";
import { LinearProgress, Typography } from "@material-ui/core";
import GroupPanel from "./GroupPanel";
import SubGroupPanel from "./SubGroupPanel";
import StepperDetailCourse from "../StepperDetailCourse";
import { useStyles } from "./styles";

const ProgramingOnDemandGrouped = ({
  groups = {},
  selectStep,
  defaultModule,
  openQuestionFromCurrentLessonWithQuestionId,
  onOpenSubmodule,
  finalResultsByScheduleId,
  isLoadingFinalResult = false,
  settingCommerce,
  isLoadingDetail,
}) => {
  const classes = useStyles();
  const [expandedGroup, setExpandedGroup] = React.useState(
    Object.entries(groups).length === 1
      ? Object.keys(groups)[0]
      : defaultModule || null
  );
  const [expandedSubGroups, setExpandedSubGroups] = React.useState({});
  const formatTimeString = (totalTime) => {
    if (!totalTime || totalTime === "00:00:00") return "";
    const [h, m, s] = totalTime.split(":").map(Number);
    return `${h}h ${m}min`;
  };

  return (
    <div className={classes.root}>
      {Object.entries(groups).map(([groupName, groupData]) => {
        const { total_tempo, total_registros } = groupData;
        const timeString = formatTimeString(total_tempo);
        const infoParts = [
          `${Object.keys(groupData.groups || {}).length} tópicos`,
          `${total_registros} aulas`,
          timeString,
        ]
          .filter(Boolean)
          .join(" • ");

        return (
          <GroupPanel
            key={groupName}
            accordionProps={{
              className: classes.groupHeaderContainer,
              expanded: expandedGroup === groupName,
              onChange: (_, isExpanded) =>
                setExpandedGroup(isExpanded ? groupName : null),
            }}
            title={
              <div className={classes.groupPanelTitleContainer}>
                <Typography className={classes.groupHeader}>
                  {groupName}
                </Typography>
                {infoParts && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    className={classes.groupHeaderInfo}
                  >
                    {infoParts}
                  </Typography>
                )}
              </div>
            }
          >
            {Object.entries(groupData.groups || {}).map(
              ([subGroupName, subGroupData]) => {
                const {
                  total_tempo: subTotalTime,
                  total_registros: subTotalRegistros,
                } = subGroupData;
                const subTimeString = formatTimeString(subTotalTime);
                const subInfoParts = [
                  `${subTotalRegistros} aulas`,
                  subTimeString,
                ]
                  .filter(Boolean)
                  .join(" • ");

                return (
                  <SubGroupPanel
                    key={subGroupName}
                    selectStep={selectStep}
                    sessionsArray={subGroupData.presentations}
                    accordionProps={{
                      className: classes.groupHeaderContainer,
                      expanded: expandedSubGroups[groupName] === subGroupName,
                      onChange: (_, isExpanded) => {
                        if (
                          isExpanded &&
                          typeof onOpenSubmodule === "function"
                        ) {
                          const anySession = Object.values(
                            subGroupData.presentations || {}
                          )[0];
                          const activityScheduleDetailId =
                            anySession?.agenda_atividade_detalhe_pai_id;
                          if (activityScheduleDetailId) {
                            onOpenSubmodule(activityScheduleDetailId);
                          }
                        }

                        setExpandedSubGroups((prev) => ({
                          ...prev,
                          [groupName]: isExpanded ? subGroupName : null,
                        }));
                      },
                    }}
                    title={
                      <Typography variant="subtitle1">
                        {subGroupName}
                      </Typography>
                    }
                    infoString={subInfoParts}
                  >
                    {(isLoadingFinalResult || isLoadingDetail) && (
                      <LinearProgress />
                    )}
                    {Object.entries(subGroupData.presentations || {}).map(
                      ([sessionTitle, sessionData]) => (
                        <div key={sessionTitle}>
                          <StepperDetailCourse
                            steps={[
                              { ...sessionData, titulo_palestra: sessionTitle },
                            ]}
                            selectStep={selectStep}
                            openQuestionFromCurrentLessonWithQuestionId={
                              openQuestionFromCurrentLessonWithQuestionId
                            }
                            finalResults={
                              finalResultsByScheduleId
                                ? finalResultsByScheduleId[
                                    sessionData.agenda_atividade_detalhe_pai_id ||
                                      sessionData.agenda_atividade_detalhe_id
                                  ] || []
                                : []
                            }
                            isLoadingFinalResult={isLoadingFinalResult}
                            settingCommerce={settingCommerce}
                            isLoadingDetail={isLoadingDetail}
                          />
                        </div>
                      )
                    )}
                  </SubGroupPanel>
                );
              }
            )}
          </GroupPanel>
        );
      })}
    </div>
  );
};

export default ProgramingOnDemandGrouped;
